export const PUBLIC_SHELL_READY_EVENT = 'lobu:public-shell-ready';
const PUBLIC_LOADING_SELECTOR = '[data-public-loading="true"]';

export function isPublicShellRootReady({
  textContent,
  hasPendingPublicLoading,
}: {
  textContent: string | null | undefined;
  hasPendingPublicLoading: boolean;
}) {
  return Boolean(textContent?.trim()) && !hasPendingPublicLoading;
}

export function isRootReadyForPublicShellHide(root: Element | null) {
  if (!root) return false;
  return isPublicShellRootReady({
    textContent: root.textContent,
    hasPendingPublicLoading: Boolean(root.querySelector(PUBLIC_LOADING_SELECTOR)),
  });
}

export function markPublicShellReady() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(PUBLIC_SHELL_READY_EVENT));
}

export function hidePublicShellAfterPaint(shell: HTMLElement, removeShell: () => void) {
  // Background tabs suspend animation frames. A ready app must still become
  // clickable, including when a visible tab is hidden before its next paint.
  let finished = false;
  let fallback: number | undefined;
  const finish = () => {
    if (finished) return;
    finished = true;
    document.removeEventListener('visibilitychange', finishWhenHidden);
    shell.removeEventListener('transitionend', finish);
    window.clearTimeout(fallback);
    removeShell();
  };
  const finishWhenHidden = () => {
    if (document.visibilityState === 'hidden') finish();
  };
  if (document.visibilityState === 'hidden' ||
      !document.documentElement.classList.contains('public-app-loading')) {
    finish();
    return;
  }
  document.addEventListener('visibilitychange', finishWhenHidden);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (finished) return;
      if (document.documentElement.classList.contains('public-app-loading')) {
        finish();
        return;
      }
      shell.classList.add('is-hidden');
      shell.addEventListener('transitionend', finish, { once: true });
      // transitionend is not guaranteed to fire; bound the fade.
      fallback = window.setTimeout(finish, 400);
    });
  });
}
